import Icon from '@/icons/index';
import React from 'react';

import RoundedButton from '@/components/common/RoundedButton';

const IconTitleDescCtaCard = (props) => {
  const {
    icon,
    title,
    desc,
    ctaTitle,
    ctaType = 'primary',
    ctaIcon,
    isCtaDisabled,
    onCtaClick
  } = props;

  return (
    <div className="c-IconTitleDescCtaCard flex h-full w-full flex-col gap-12 rounded-12 bg-npl-neutral-light-solid-3 p-16 hover:bg-npl-neutral-light-solid-4 lg:flex-row-reverse lg:justify-between lg:p-24">
      <div className="h-64 w-64">{icon}</div>
      <div className="w-full lg:flex lg:flex-col lg:justify-between">
        <div>
          <h4 className="text-label-lg font-semibold text-npl-neutral-light-solid-12">
            {title}
          </h4>
          <p className="mt-4 text-body-sm text-dark-1b text-opacity-65">
            {desc}
          </p>
        </div>
        {onCtaClick ? (
          <div className="mt-16 lg:mt-24">
            <RoundedButton
              size="sm"
              disabled={isCtaDisabled}
              displayType={ctaType}
              onClick={onCtaClick}>
              <div className="flex items-center space-x-8">
                <span>{ctaTitle}</span>
                {ctaIcon && <Icon name={ctaIcon} width={16} height={16} />}
              </div>
            </RoundedButton>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default IconTitleDescCtaCard;
